module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('img', {
    staticClass: "cursor",
    attrs: {
      "src": _vm.captcha.blobUrl
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.refresh($event)
      }
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-31a6c69c"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/common/widget/NbCaptcha.vue
// module id = 966
// module chunks = 1